import RogoLogo from "../../../../assets/images/icon.svg";

export const LoadingComponent = () => {
	return (
		// load assets/images/icon.svg and make it spin
		<img
			id="rogoloader"
			src={RogoLogo}
			alt="Rogo Logo"
			// React 19 recognises camelCase `fetchPriority` as a first-class DOM prop.
			// The lowercase spread this replaces was a React 18 workaround that the
			// upgrade inverted: React 19 rejects `fetchpriority` with "Invalid DOM
			// property", so the workaround had become the noise it was avoiding.
			fetchPriority="high"
			style={{
				animation: "spin 2s linear infinite",
			}}
			height={200}
			width={200}
		/>
	);
};
